import React from 'react';
import type { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Admin from '../pages/admin/page';
import Login from '../pages/login/page';
import Stores from '../pages/stores/page';
import Categories from '../pages/categories/page';
import Blog from '../pages/blog/page';
import Contacts from '../pages/contacts/page';
import StoreDetail from '../pages/store-detail/page';
import About from '../pages/about/page';
import HowItWorks from '../pages/how-it-works/page';
import Privacy from '../pages/privacy/page';
import Terms from '../pages/terms/page';
import Faq from '../pages/faq/page';
import CategoryDetail from '../pages/category-detail/page';
import TopDeals from '../pages/top-deals/page';
import NotFound from '../pages/NotFound';
import Partners from '../pages/partners/page';
import { ADMIN_ENABLED } from '../utils/adminAccess';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/stores',
    element: <Stores />,
  },
  {
    path: '/store/:slug',
    element: <StoreDetail />,
  },
  {
    path: '/categories',
    element: <Categories />,
  },
  {
    path: '/category/:id',
    element: <CategoryDetail />,
  },
  {
    path: '/top-deals',
    element: <TopDeals />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorks />,
  },
  {
    path: '/partners',
    element: <Partners />,
  },
  {
    path: '/contacts',
    element: <Contacts />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/faq',
    element: <Faq />,
  },
  ...(ADMIN_ENABLED
    ? [
        {
          path: '/login',
          element: <Login />,
        },
        {
          path: '/admin',
          element: <Admin />,
        },
      ]
    : []),
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
